import './style.scss';
import {gsap} from 'gsap';
import {imageLazyLoading} from '../../scripts/functions/imageLazyLoading';
import {animations} from '../../scripts/general/animations';
/**
 *
 * @param header {HTMLElement}
 * @returns {Promise<void>}
 */
export default async (header) => {
  if (header.dataset.accessibleHeaderInitialized === 'true') return;
  header.dataset.accessibleHeaderInitialized = 'true';

  const burgerMenu = header.querySelector('.burger-menu');
  const menuLinks = header.querySelector('.navbar');
  const skipLink = document.querySelector('[skip-to-main-content]');
  const main = document.querySelector('#main-content');

  if (!burgerMenu || !menuLinks) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const burgerTl = gsap.timeline({
    paused: true,
  });

  const burgerSpans = burgerMenu.querySelectorAll('span');

  gsap.set(burgerSpans, {
    transformOrigin: '50% 50%',
  });

  burgerTl
    .to(burgerSpans, {
      y: (index) => index === 0 ? 4 : -4,
      duration: reducedMotion.matches ? 0 : 0.25,
      ease: 'power2.inOut',
    })
    .to(burgerSpans, {
      rotation: (index) => index === 0 ? 45 : -45,
      duration: reducedMotion.matches ? 0 : 0.25,
      ease: 'power2.inOut',
    });

  const updateStickyOffset = () => {
    document.documentElement.style.setProperty(
        '--sticky-header-offset',
        `${Math.ceil(header.getBoundingClientRect().height)}px`,
    );
  };

  const setMenuState = (isOpen) => {
    burgerMenu.classList.toggle('burger-menu-active', isOpen);
    burgerMenu.setAttribute('aria-expanded', String(isOpen));
    burgerMenu.setAttribute(
        'aria-label',
        isOpen ? 'Close primary navigation' : 'Open primary navigation',
    );
    menuLinks.classList.toggle('header-links-active', isOpen);
    menuLinks.hidden = !isOpen;
    menuLinks.inert = !isOpen;
    header.classList.toggle('header-active', isOpen);
    document.documentElement.classList.toggle('modal-opened', isOpen);

    if (isOpen) {
      burgerTl.play();
      gsap.fromTo(menuLinks.querySelectorAll('.animation'), {
        y: reducedMotion.matches ? 0 : 30,
        autoAlpha: reducedMotion.matches ? 1 : 0,
      }, {
        y: 0,
        autoAlpha: 1,
        stagger: reducedMotion.matches ? 0 : 0.05,
        duration: reducedMotion.matches ? 0 : 0.4,
        delay: reducedMotion.matches ? 0 : 0.1,
      });
    } else {
      burgerTl.reverse();
    }
  };

  setMenuState(false);
  updateStickyOffset();

  burgerMenu.addEventListener('click', () => {
    setMenuState(burgerMenu.getAttribute('aria-expanded') !== 'true');
  });

  header.addEventListener('keydown', (event) => {
    const isOpen = burgerMenu.getAttribute('aria-expanded') === 'true';
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      setMenuState(false);
      burgerMenu.focus();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [burgerMenu, ...menuLinks.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
    )].filter((element) => !element.hidden && !element.closest('[hidden]'));

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  menuLinks.addEventListener('click', (event) => {
    if (event.target.closest('a')) setMenuState(false);
  });

  skipLink?.addEventListener('click', () => {
    window.requestAnimationFrame(() => main?.focus({preventScroll: true}));
  });

  window.addEventListener('resize', updateStickyOffset, {passive: true});

  animations(header);
  imageLazyLoading(header);
};

